
import { useEffect, useState } from "react";
import { Card } from "@shared/ui/card";
import { Activity, CheckCircle, Clock, Database } from "lucide-react";
import { useValidationDashboard } from "../../hooks";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";

export const Header = () => {
    const remoteUtilityId = getRemoteUtilityId();
  
  const {data}=useValidationDashboard({
      remote_utility_id: remoteUtilityId,
    });

  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 60000); // Update every minute
    
    return () => clearInterval(timer);
  }, []);

  const formattedDate = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(currentDate);

  const summaryMetrics = [
    {
      title: "Total Meters",
      value: data?.result?.totalMeters,
      icon: <Database className="h-5 w-5 text-blue-500" />,
     
    },
    {
      title: "Total Reads",
      value: data?.result?.totalReads,
      icon: <Activity className="h-5 w-5 text-green-500" />,
     
    },
    {
      title: "Validated Reads",
      value: data?.result?.validatedReads,
      percentage: data?.result?.percentages?.validated,
      icon: <CheckCircle className="h-5 w-5 text-emerald-500" />,
      
    },  
    {
      title: "Pending Validation",
      value: data?.result?.pendingValidation,
      percentage: data?.result?.percentages?.pending,
      icon: <Clock className="h-5 w-5 text-orange-500" />,
     
    },
    {
      title: "Validation Issues",
      value: data?.result?.validationExemptions,
      percentage: data?.result?.percentages?.exempted,
      icon: <Activity className="h-5 w-5 text-red-500" />,
      
    }
  ];

  return (
    <div className="">
      <div className="flex flex-col pb-4 sm:flex-row justify-between items-start sm:items-center">
        <div>
          <h1 className="page-title">Read Validation Summary</h1>
          <p className="page-subtitle">{formattedDate}</p>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {summaryMetrics.map((metric, index) => (
          <QuickStatsCard title={metric.title} icon={metric.icon} displayValue={metric.value} />
        ))}
      </div>
    </div>
  );
};
